import { pickByPaths } from '@tradener/lumen';

import { SimulationOperationsProps } from '@graphql/query/simulation';

const mergePeriods = (
  simulationOperations: SimulationOperationsProps[],
  periods: string[],
  fallbackOperations?: SimulationOperationsProps[],
) => {
  if (!simulationOperations) return [];

  return simulationOperations.map(({ simulationItems, ...simulationOperation }) => {
    const fallbackOperation = fallbackOperations?.find(({ id }) => id === simulationOperation.id);
    const fallbackSimulationItems = fallbackOperation?.simulationItems;

    return {
      ...pickByPaths(simulationOperation, 'id', 'operation', 'submarket', 'energyType', 'priceType'),
      simulationItems: periods.map((period) => {
        const currentSimulationItem = simulationItems.find(({ competence }) => competence === period);
        const fallbackSimulationItem = fallbackSimulationItems?.find(({ competence }) => competence === period);
        const simulationItemSource = currentSimulationItem || fallbackSimulationItem;
        const simulationItem = {
          competence: period,
          quantityMwm: '' as unknown as number,
          price: '' as unknown as number,
        };

        if (simulationItemSource) {
          simulationItem.quantityMwm = simulationItemSource.quantityMwm;
          simulationItem.price = simulationItemSource.price;
        }

        return simulationItem;
      }),
    };
  });
};

export default mergePeriods;
